interface AppUpdateBannerProps {
  remoteVersion?: string | null;
  onUpdate: () => void;
  onDismiss: () => void;
}

export function AppUpdateBanner({ remoteVersion, onUpdate, onDismiss }: AppUpdateBannerProps) {
  return (
    <div className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-md animate-slide-up">
      <div className="rounded-2xl border border-[#E0001B]/20 bg-white p-4 shadow-xl">
        <p className="text-[14px] font-semibold text-[#1A1A1A]">Update available</p>
        <p className="mt-1 text-[12px] text-[#666]">
          A newer version of the rider app is ready
          {remoteVersion ? ` (v${remoteVersion})` : ''}. Refresh to get the latest fixes.
        </p>
        <div className="mt-3 flex gap-2">
          <button
            type="button"
            onClick={onUpdate}
            className="flex-1 rounded-xl bg-[#E0001B] px-4 py-2 text-[13px] font-semibold text-white"
          >
            Refresh now
          </button>
          <button
            type="button"
            onClick={onDismiss}
            className="rounded-xl border border-[#E5E5E5] px-4 py-2 text-[13px] font-medium text-[#666]"
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
